import Vue from "vue";
import VueApexCharts from "vue-apexcharts";
Vue.prototype.$lodash = require("lodash");
Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);

export default async ({ store }) => {};
